export enum Profiles {
    Startup = 1,
    Investor = 2,
    Cofounder = 3,
    Manufacturer = 4,
    BuyerOfStartup = 5,
    HavingCapacity = 6,
    LookingForCapacity = 7
}
